import { Box, Text } from '@chakra-ui/react';
import { getStatusMap, statusFormatter } from '@diamond/shared/utils';
import { SO_STATUS_CONFIG, SOStatus } from '@diamond/sol-buyer/constant';

interface StatusBadgeProps {
  status: string;
  reason?: string | null;
  sapNote?: string | null;
}

const getStatusDotColor = (colorName: string): string => {
  const colorMap: Record<string, string> = {
    orange: '#E28800',
    blueDark: '#0068A3',
    purple: '#5200A3',
    iosBlue: '#007AFF',
    blue: '#0068A3',
    darkGreen: '#005527',
    red: '#FF0000',
  };

  return colorMap[colorName] || '#E28800';
};

export const StatusBadge = ({ status, reason, sapNote }: StatusBadgeProps) => {
  if (status === 'draft') {
    return null;
  }

  // If status is an SO status, use SO_STATUS_CONFIG for label and dot
  if (status in SO_STATUS_CONFIG) {
    const soConfig = SO_STATUS_CONFIG[status as SOStatus];
    const dotColor = soConfig.dotColor || getStatusDotColor(soConfig.color);
    const label = soConfig.label;

    return (
      <Box
        bg="white"
        borderRadius="md"
        px="8px"
        display="flex"
        alignItems="center"
        gap="2"
      >
        <Box w="8px" h="8px" borderRadius="full" bg={dotColor} flexShrink={0} />
        <Text
          fontSize="xs"
          fontWeight="semibold"
          color="#0941A8"
          textTransform="capitalize"
        >
          {label}
        </Text>
      </Box>
    );
  }

  const statusMap = getStatusMap(status, reason, sapNote);
  const dotColor = getStatusDotColor(statusMap.stateOptions.color);

  return (
    <Box
      bg="white"
      borderRadius="md"
      px="8px"
      display="flex"
      alignItems="center"
      gap="2"
    >
      <Box w="8px" h="8px" borderRadius="full" bg={dotColor} flexShrink={0} />
      <Text
        fontSize="xs"
        fontWeight="semibold"
        color="#0941A8"
        textTransform="capitalize"
      >
        {statusFormatter(status, reason, sapNote)}
      </Text>
    </Box>
  );
};
